var _rect, _text, _rect2, _rect3, _rect4, _text2, _rect5, _text3, _path, _polygon, _rect6, _text4, _path2, _polygon2, _rect7, _text5, _text6, _rect8, _rect9, _rect10, _text7, _rect11, _text8, _path3, _polygon3, _rect12, _text9, _path4, _polygon4, _rect13, _text10, _rect14, _text11, _rect15, _text12, _rect16, _text13, _text14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02ChatbotVsAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 360",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 360,
    fill: "#fafafa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 36,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Without a World Outside the Model")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 380,
    height: 250,
    rx: 14,
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 380,
    height: 44,
    rx: 14,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 380,
    height: 14,
    fill: "#fecaca"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 98,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Prompt Only = Chatbot")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 140,
    width: 100,
    height: 44,
    rx: 8,
    fill: "#f3f4f6",
    stroke: "#111",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "User")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 162 L248 162",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "252,162 242,156 242,168",
    fill: "#111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "LLM")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315 184 L315 210",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "315,214 309,204 321,204",
    fill: "#111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 218,
    width: 170,
    height: 44,
    rx: 8,
    fill: "#fef3c7",
    stroke: "#111",
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 246,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Text reply only")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 295,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "No tools. No memory. No proof.")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 70,
    width: 380,
    height: 250,
    rx: 14,
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 70,
    width: 380,
    height: 44,
    rx: 14,
    fill: "#bbf7d0",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 100,
    width: 380,
    height: 14,
    fill: "#bbf7d0"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 98,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "With Harness = Agent")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 140,
    width: 80,
    height: 40,
    rx: 8,
    fill: "#f3f4f6",
    stroke: "#111",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 165,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "User")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 160 L630 160",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "634,160 624,154 624,166",
    fill: "#111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 140,
    width: 90,
    height: 40,
    rx: 8,
    fill: "#bfdbfe",
    stroke: "#111",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 165,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Harness")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M730 160 L760 160",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "764,160 754,154 754,166",
    fill: "#111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 140,
    width: 60,
    height: 40,
    rx: 8,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 165,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "LLM")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 210,
    width: 90,
    height: 36,
    rx: 8,
    fill: "#e0e7ff",
    stroke: "#111",
    strokeWidth: 2
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 233,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Tools")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 210,
    width: 90,
    height: 36,
    rx: 8,
    fill: "#fce7f3",
    stroke: "#111",
    strokeWidth: 2
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 233,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Memory")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 210,
    width: 100,
    height: 36,
    rx: 8,
    fill: "#d1fae5",
    stroke: "#111",
    strokeWidth: 2
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 233,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Validation")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 295,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Can act, remember, and verify.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02ChatbotVsAgent);
export default __webpack_public_path__ + "static/media/02-chatbot-vs-agent.52331c8360220c801fe81e0e9c1954bf.svg";
export { ForwardRef as ReactComponent };